<template>
    <div class="granish-detail-page">
        <!-- begin loading -->
        <div v-if="pageLoading" class="page-loading-container">
            <v-progress-circular
                :size="60"
                :width="5"
                color="primary"
                indeterminate
            ></v-progress-circular>
        </div>
        <!-- end loading -->

        <div class="wrapper" v-show="!pageLoading">
            <!-- begin 商品详情 -->
            <v-container class="delivery-container" v-if="showImage">
                <v-layout class="delivery-summary">
                    <div
                        class="cover-container"
                        :class="{ 'only-one-img': delivery.images && delivery.images.length === 1 }"
                        v-if="delivery.images && delivery.images.length"
                    >
                        <v-carousel>
                            <v-carousel-item
                                class="cover"
                                :src="item.url"
                                :key="index"
                                v-for="(item, index) in delivery.images"
                            >
                            </v-carousel-item>
                        </v-carousel>
                    </div>
                    <div class="summary-container">
                        <h1 class="delivery-name">
                            {{ delivery.name }}
                        </h1>
                        <div class="delivery-price">
                            €{{ delivery.price | fixed(2, true) }}
                        </div>
                        <div class="allergen-list">
                            <div
                                class="item"
                                v-for="it in delivery.allergen"
                                :key="it.guid"
                            >
                                <img
                                    style="width:20px;height: 20px;"
                                    :src="it.image"
                                    alt=""
                                />
                            </div>
                        </div>
                        <div class="summary">
                            {{ delivery.description }}
                        </div>
                    </div>
                    <!-- begin 选择数量 -->
                </v-layout>
            </v-container>
            <!-- end 商品详情 -->

            <!-- begin 选择套餐-->
            <v-container
                class="garnish-container"
                v-if="delivery.garnish && delivery.garnish.length != 0"
            >
                <div class="garnish-title">{{ $t("garnish.title") }}</div>
                <div
                    class="garnish-item"
                    :key="index"
                    v-for="(item, index) in delivery.garnish"
                >
                    <div class="garnish-name">
                        {{
                            (item.commodity_name_json &&
                                item.commodity_name_json[getTranslateIndex]) ||
                            item.name
                        }}
                    </div>
                    <div class="garnish-num">
                        <div>
                            {{
                                item.min_select_type == 0
                                    ? $t("garnish.num_tip", {num: item.min_select_num})
                                    : $t("garnish.required", {num: item.min_select_num})
                            }}
                        </div>

                        <div class="must" v-if="item.min_select_num != 0">
                            {{ $t("garnish.must") }}
                        </div>
                    </div>
                    <div
                        class="commodity-item"
                        :key="com_index"
                        v-for="(com_item, com_index) in item.commodity"
                    >
                        <div class="commodity-img"
                             :style="`background-image: url(${com_item.images && com_item.images[0] && com_item.images[0].url})`">
                        </div>
                        <v-checkbox
                            class="index"
                            :id="com_item.guid"
                            v-if="pageFrom === 'store' || storeInfo.orderScanner == 1"
                            v-model="delivery.garnish[index].commodity[com_index].checked"
                            :label="(com_item.commodity_name_json && com_item.commodity_name_json[getTranslateIndex]) || com_item.commodity_name"
                            @change="changeGarnish(com_item, delivery.garnish[index].commodity[com_index].checked)"
                            :disabled="getDisabled(delivery.garnish[index].commodity[com_index], item)"
                        />
                        <div>
                            <div class="price">€{{ com_item.price }}</div>
                            <label :for="com_item.guid">
                                <div :class="{
                                commoditySelectedBtn: true,
                                checked: delivery.garnish[index].commodity[com_index].checked
                            }">{{ $t("garnish.choice") }}</div>
                            </label>
                        </div>
                    </div>
                </div>

                <div class="button-container">
                    <div class="price">Total {{ total_price }} €</div>
                    <button
                        class="button add-cart-button checked"
                        @click="handleGarnishChecked"
                        v-if="canSubmit"
                    >
                        {{ $t("delivery_detail.addToCart") }}
                    </button>
                    <button
                        class="button add-cart-button disabled-btn"
                        v-if="!canSubmit && (pageFrom === 'store' || storeInfo.orderScanner == 1)"
                    >
                        {{ $t("delivery_detail.addToCart") }}
                    </button>
                </div>
            </v-container>
            <!-- end 选择套餐-->
        </div>

        <div class="bottom-btn" @click="handleBack">
            {{ $t("delivery_detail.back") }}
        </div>

        <v-dialog v-model="passwordTip" max-width="500px">
            <v-card>
                <v-card-title>
                    <span>{{ tip }}</span>
                    <v-spacer></v-spacer>
                </v-card-title>
                <v-card-actions>
                    <v-btn color="primary" flat @click="passwordTip = false">
                        {{ $t("common.close") }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- begin 选择属性 -->
        <v-dialog v-model="isShowAttributes" max-width="500px">
            <v-card color="#fff">
                <div
                    class="check-attributes-container-layout"
                    v-if="attrList && attrList.length != 0"
                >
                    <div class="attributes-title">
                        <div>{{ $t("delivery.attribute") }}</div>
                    </div>
                    <div class="attributes-subtitle">
                        <div>{{ $t("delivery.attribute_tip") }}</div>
                    </div>
                    <div v-for="(cate, cateIndex) in attrList" :key="cate.guid">
                        <div class="title">{{ cate.attr_cate_name }}（{{$t(cate.type === 0 ? "unClass.add389" : 'unClass.add392', {num: cate.min_limit})}}）</div>
                        <div class="attributes-content">
                            <div
                                v-for="(item, index) in (cate.attributes || [])"
                                :key="index"
                                :class="{ item: true, active: checkedAttr.includes(item.guid) }"
                                @click="checkAttr(item, cateIndex, index)"
                            >
                                {{ item.name }}{{ Number(item.price) ? ` €${item.price}` : `` }}
                            </div>
                        </div>
                    </div>
                    <button
                        class="button attribute-button"
                        @click="closeAttr($event)"
                    >
                        {{ $t("delivery_detail.confirm") }}
                    </button>
                </div>
            </v-card>
        </v-dialog>
        <!-- end 选择属性 -->
    </div>
</template>

<script>
import {validationMixin} from "vuelidate";
import {required, integer, minValue} from "vuelidate/lib/validators";
import {mapGetters, mapMutations, mapActions, mapState} from "vuex";
import {fixed} from "../../utils";

export default {
    mixins: [validationMixin],
    validations: {
        num: {required, integer, minValue: minValue(1)}
    },
    data() {
        return {
            added: false,
            pageLoading: false,

            passwordTip: false,
            tip: "",

            total_price: 0,

            canSubmit: false,

            isShowAttributes: false,
            attrList: [], //当前选择的属性
            attrGoodsGuid: null, //当前选择属性的商品guid
            checkedAttr: [], //选择的属性枚举
        };
    },
    mounted() {
        this.initData();
        this.getStoreInfo();
    },
    computed: {
        ...mapGetters({
            delivery: "currentDelivery"
        }),
        ...mapGetters(["cart", "getTranslateIndex"]),
        ...mapState(["carts", "tableGuid", "storeInfo", "pageFrom"]),

        currentCart() {
            return this.cart.items.find(item => item.guid === this.delivery.guid);
        },

        showImage() {
            return this.$route.query.showImage == 1;
        }
    },
    methods: {
        ...mapMutations(["addToCart", "minusFromCart", "setDelivery", "resetCart"]),
        ...mapActions(["getDeliveryDetail", "updateQrcodeCart", "getStoreInfo"]),
        getDisabled(commodity, item){
            if(commodity.checked) return false;
            if(item.min_select_type === 0){
                return false;
            }else if(item.min_select_type === 1){
                return item.chexked_num >= item.min_select_num
            }
            return false;
        },
        handleAddToCart() {
            this.addToCart({
                num: 1,
                guid: this.delivery.guid
            });
        },
        handleMinusFromCart() {
            this.minusFromCart({
                num: 1,
                guid: this.delivery.guid
            });
        },
        async initData() {
            this.pageLoading = true;
            const guid = this.$route.params.id;
            await this.getDeliveryDetail({guid});
            this.pageLoading = false;
            this.total_price = this.delivery.price;
        },

        handleBack() {
            // this.updateQrcodeCart();
            this.$router.back();
        },

        closeAttr(){
            let flag = true;
            this.attrList.forEach(item=>{
                if(!this.$allowAddAttr(this.attrList, this.checkedAttr, null, item)) flag = false;
            });
            if(!flag) return ;
            this.isShowAttributes = false;
            this.attrList = [];
            this.attrGoodsGuid = null;
            this.checkedAttr = [];
        },
        /**
         * 选择属性标签
         */
        checkAttr(attr) {
            this.delivery.garnish.map((item, index) => {
                item.commodity.map((com_item, _index) => {
                    if (com_item.guid === this.attrGoodsGuid) {
                        let checkedAttr = this.delivery.garnish[index].commodity[_index].checkedAttr || [];
                        if(this.checkedAttr.length !== checkedAttr.length){
                            checkedAttr = [];
                        }
                        if(checkedAttr.includes(attr.guid)){
                            checkedAttr.splice(checkedAttr.findIndex(it=>it === attr.guid), 1);
                        }else{
                            checkedAttr.push(attr.guid);
                        }
                        this.checkedAttr = checkedAttr;
                        this.delivery.garnish[index].commodity[_index].checkedAttr = checkedAttr;
                    }
                });
            });
        },
        changeGarnish(item, checked) {
            if(item.attributes_cate && item.attributes_cate.length && checked){
                this.isShowAttributes = true;
                this.attrGoodsGuid = item.guid;
                this.attrList = item.attributes_cate;
                this.checkedAttr = [];
            }

            this.total_price = 0;
            this.canSubmit = true;
            this.delivery.garnish.map((item, index) => {
                this.delivery.garnish[index].chexked_num = 0;

                item.commodity.map(com_item => {
                    if (com_item.checked) {
                        this.delivery.garnish[index].chexked_num += 1;
                        this.total_price += parseFloat(com_item.price);
                    }
                });
                if(item.min_select_type === 0){
                    if(this.delivery.garnish[index].chexked_num < item.min_select_num){
                        this.canSubmit = false;
                    }
                }else if(item.min_select_type === 1){
                    if(this.delivery.garnish[index].chexked_num !== item.min_select_num){
                        this.canSubmit = false
                    }
                }
            });

            this.total_price += parseFloat(this.delivery.price);
        },

        handleGarnishChecked() {
            let lack_name = [];
            let chencked_garnish = [];
            let chencked_garnish_items = [];
            let total_price = 0;

            this.delivery.garnish.map((item, index) => {
                this.delivery.garnish[index].chexked_num = 0;
                item.commodity.map(com_item => {
                    if (com_item.checked) {
                        this.delivery.garnish[index].chexked_num += 1;
                        chencked_garnish.push({
                            attributes_guid: com_item.checkedAttr,
                            commodity_guid: com_item.commodity_guid,
                            commodity_name: com_item.commodity_name,
                            commodity_price: com_item.commodity_price,
                            guid: com_item.guid,
                            quantity: 1
                        });
                        chencked_garnish_items.push(com_item);
                        total_price += parseFloat(com_item.price);
                    }
                });

                if (item.min_select_num > item.chexked_num) {
                    lack_name.push(item.name);
                }
            });

            if (lack_name.length != 0) {
                this.tip = lack_name.join(", ") + this.$t("garnish.required");
                this.passwordTip = true;
                return;
            }

            total_price += parseFloat(this.delivery.price);

            let payload = {
                num: 1,
                guid: this.delivery.guid,
                garnish: chencked_garnish,
                garnish_items: chencked_garnish_items,
                total_price
            };
            this.addToCart(payload);

            if (this.tableGuid) {
                this.updateQrcodeCart();
            }

            this.$router.back();
        }
    },
    filters: {
        fixed
    }
};
</script>

<style scoped lang="sass" src="./detail.sass"></style>
